// Controls
import { BaseComponent } from "@ms/uno-controls/lib/local/controls/BaseComponent";
import { UnoLeftNavOption } from "./UnoLeftNavOption";
import { FocusZone, FocusZoneDirection, getRTL, Icon, Label, List } from "@fluentui/react";
// Utilities
import React from "react";
import { css } from "@fluentui/utilities/lib/css";
import { Strings } from "../../utilities/CultureUtilities";
// Constants
import { ComponentNames } from "../../constants/ComponentNames";
// Styles
import { getUnoLeftNavClassNames, getUnoLeftNavStyles } from "./UnoLeftNav.styles";
import { withTheme } from "@ms/uno-controls/lib/local/utilities/withTheme";
import { infoSmallIconProps } from "@ms/uno-controls/lib/local/icons/icons.styles";
/**
 * Left nav component for rendering pinned section
 */ class UnoLeftNavPinnedSectionInternal extends BaseComponent {
    /**
     * Name of this component. Used for usage logging.
     */ name() {
        return ComponentNames.UnoLeftNavPinnedSection;
    }
    /**
     * Render the Uno leftNav pinned section
     */ renderComponent() {
        const leftNavClassNames = this.getLeftNavClassNames();
        const pinnedOptionsList = this.renderPinnedOptionsList();
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Label, {
            className: leftNavClassNames.pinnedSectionHeader
        }, Strings.UnoLeftNav_PinnedText), pinnedOptionsList);
    }
    /**
     * Render the pinned options list
     */ renderPinnedOptionsList() {
        const { pinnedOptions, shouldRenderPinnedError } = this.props;
        if (shouldRenderPinnedError) {
            return this.renderErrorPinnedSectionState();
        }
        if (pinnedOptions.length === 0) {
            return this.renderEmptyPinnedSectionState();
        }
        const leftNavClassNames = this.getLeftNavClassNames();
        const className = css("list", leftNavClassNames.leftNavOptionsList);
        return /*#__PURE__*/ React.createElement(FocusZone, {
            direction: FocusZoneDirection.vertical
        }, /*#__PURE__*/ React.createElement(List, {
            items: pinnedOptions,
            onRenderCell: this.onRenderCell,
            className: className,
            role: "menubar"
        }));
    }
    /**
     * Render the empty pinned section state
     */ renderEmptyPinnedSectionState() {
        const leftNavClassNames = this.getLeftNavClassNames();
        return /*#__PURE__*/ React.createElement(Label, {
            className: leftNavClassNames.emptyPinnedSectionContent
        }, Strings.UnoLeftNav_EmptyPinnedSectionText);
    }
    /**
     * Render the error pinned section state
     */ renderErrorPinnedSectionState() {
        const { onRetryButtonClicked } = this.props;
        const leftNavClassNames = this.getLeftNavClassNames();
        return /*#__PURE__*/ React.createElement("div", {
            className: leftNavClassNames.errorPinnedSectionContent
        }, /*#__PURE__*/ React.createElement("div", {
            className: "errorMessage"
        }, /*#__PURE__*/ React.createElement(Icon, infoSmallIconProps), /*#__PURE__*/ React.createElement("span", null, Strings.UnoLeftNav_ErrorPinnedSectionText)), /*#__PURE__*/ React.createElement("button", {
            className: "retryButton",
            onClick: onRetryButtonClicked
        }, Strings.UnoLeftNav_ErrorPinnedSectionRetryButtonText));
    }
    /**
     * Get the classnames associated with the computed styles for the Uno leftNav
     */ getLeftNavClassNames() {
        return getUnoLeftNavClassNames(getUnoLeftNavStyles(this.props.isLeftNavCollapsed, this.props.theme, getRTL()));
    }
    constructor(...args){
        super(...args), /**
     * Callback to render a custom cell
     * @param optionCellInfo Option info for the cell
     */ this.onRenderCell = (optionCellInfo, index)=>{
            const { keyCodeMapper } = this.props;
            return /*#__PURE__*/ React.createElement(UnoLeftNavOption, {
                ...optionCellInfo,
                key: index.toString(),
                keyCodeMapper: keyCodeMapper
            });
        };
    }
}
export const UnoLeftNavPinnedSection = withTheme(UnoLeftNavPinnedSectionInternal);
